import type { BaseModelAttributes } from './base';
import { I18nLabels } from './common';
import { Locale } from './locale';

/**
 * 项目设定类型枚举
 * 对应设计图中的左侧导航：世界观、写作风格、故事梗概
 */
export enum ProjectSettingType {
  WORLDVIEW = 'worldview',           // 世界观
  WRITING_STYLE = 'writing_style',   // 写作风格
  ART_STYLE = 'art_style',           // 艺术风格
  STORY_SYNOPSIS = 'story_synopsis'  // 故事梗概
}

export const ProjectSettingTypeLabels: I18nLabels<ProjectSettingType> = {
  [ProjectSettingType.WORLDVIEW]: { [Locale.ZH_CN]: '世界观', [Locale.EN_US]: 'Worldview' },
  [ProjectSettingType.WRITING_STYLE]: { [Locale.ZH_CN]: '写作风格', [Locale.EN_US]: 'Writing Style' },
  [ProjectSettingType.ART_STYLE]: { [Locale.ZH_CN]: '艺术风格', [Locale.EN_US]: 'Art Style' },
  [ProjectSettingType.STORY_SYNOPSIS]: { [Locale.ZH_CN]: '故事梗概', [Locale.EN_US]: 'Story Synopsis' },
};

/**
 * 项目设定接口
 * 每个项目可以有多个设定，每种类型一个
 */
export interface IProjectSetting extends BaseModelAttributes {
  projectId: string;               // 所属项目ID
  userId: string;                  // 所属用户ID
  settingType: ProjectSettingType; // 设定类型
  content: string;                 // 设定内容（富文本）
  isAiGenerated?: boolean;         // 是否由AI生成
  project?: {
    id: string;
    name: string;
  };
}

export interface CreateProjectSettingRequest {
  projectId: string;
  settingType: ProjectSettingType;
  content: string;
  isAiGenerated?: boolean;
}

export interface UpdateProjectSettingRequest {
  content?: string;
  isAiGenerated?: boolean;
}

export interface ProjectSettingQuery {
  projectId?: string;
  settingType?: ProjectSettingType;
}

/**
 * AI生成项目设定请求
 */
export interface GenerateProjectSettingRequest {
  projectId: string;
  settingType: ProjectSettingType;
  prompt?: string;  // 可选的额外提示
}
